/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { PiQuestionLight } from "react-icons/pi";
import { PiEyeLight } from "react-icons/pi";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa6";
import { Link } from "react-router-dom";
import USDCIcon from "assets/img/icons/usdc.png";
import { HiOutlineLightBulb } from "react-icons/hi";
import { useState } from "react";

const LeaderBoard = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container py-6">
          <div className="w-full px-5">
            <div className="w-full flex items-center ">
              <div className="md:flex justify-between w-full md:py-6">
                <p className="relative text-header text-white md:mb-0 mb-4">Token Leaderboad</p>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
            <div className="w-full flex text-center mt-3 md:mt-1">
              <div className="ml-auto mr-auto md:mr-0 flex gap-4">
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Buy <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Exchange <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Play <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-12 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden">
            <div className="flex gap-2.5 p-5">
              <button className={`btn btn-tab ${tabIndex === 0 ? 'active' : ''}`} onClick={() => setTabIndex(0)}>
                All Tokens
              </button>
              <button className={`btn btn-tab ${tabIndex === 1 ? 'active' : ''}`} onClick={() => setTabIndex(1)}>
                Transfers
              </button>
            </div>
            <div className="flex flex-col">
              <div className={`w-full ${tabIndex === 0 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3 px-5">
                A total of 1,458,744 Token Contracts found
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0">#</th>
                        <th className="">Token</th>
                        <th className="">Symbol</th>
                        <th className="">Price</th>
                        <th className="">Change (%)</th>
                        <th className="">Volume (24h)</th>
                        <th className="">Circulating Market Cap</th>
                        <th className="">Holders</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(3).fill(0).map((data, index) => <tr>
                          <td className="!pr-0">
                            <a href="#" className="text-large">{index + 1}</a>
                          </td>
                          <td>
                            <Link to="/token/usdc" className="text-small flex items-center gap-1 !leading-none">
                              <img
                                src={USDCIcon}
                                width={24}
                                height={24}
                              />
                              USDC
                            </Link>
                          </td>
                          <td>
                            <p className="text-small ">USDC</p>
                          </td>
                          <td>
                            <p className="text-small ">$0.9996</p>
                            <p className="text-small text-gray-700 dark:text-gray-300">0.9996 BBA</p>
                          </td>
                          <td>
                            <p className="text-small text-green-900">+1.34%</p>
                          </td>
                          <td>
                            <p className="text-small ">$50,170,530,484.00</p>
                          </td>
                          <td>
                            <p className="text-small">$76,889,775,071.39</p>
                          </td>
                          <td>
                            <p className="text-small">4,547,587<span className="text-xsmall text-green-900">+1.45%</span></p>
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="p-5 justify-center md:justify-between flex mb-2">
                  <div className="md:flex gap-2 hidden">
                    <span className="text-small flex items-center">Show</span>
                    <select className="text-small">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                    <span className="text-small flex items-center">Per Page</span>
                  </div>
                  <div className="flex gap-2">
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                    <span className="text-small flex items-center px-2">Page 1 of 25</span>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
                  </div>
                </div>
              </div>
              <div className={`w-full ${tabIndex === 1 ? '' : 'hidden'}`}>
                <div className="not-italic text-large mb-3 px-5">
                More than 10,000,000 transactions found
                </div>
                <div className="table-wrapper">
                  <table className="table w-full">
                    <thead>
                      <tr className="">
                        <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large" data-for="txs-tip" data-tip="See preview of Transactions Details"><PiQuestionLight /></a></th>
                        <th className="">Token</th>
                        <th className="">Txn Hash</th>
                        <th className="">Block</th>
                        <th className="">Age</th>
                        <th className="">From</th>
                        <th className="">To</th>
                        <th className="">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Array(3).fill(0).map((data, index) => <tr className="">
                          <td className="!pr-0">
                            <a href="#" className="text-large"><PiEyeLight /></a>
                          </td>
                          <td>
                            <Link to="/token/usdc" className="text-small flex items-center gap-1">
                              <img
                                src={USDCIcon}
                                width={24}
                                height={24}
                              />
                              USDC
                            </Link>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                                  3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                                </Link>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small text-green-900">109,901,461</p>
                          </td>
                          <td>
                            <p className="text-small ">12 secs ago</p>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <div className="flex gap-[1px] max-w-[160px]">
                              <div className="truncateWrapper">
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              </div>
                              <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                            </div>
                          </td>
                          <td>
                            <p className="text-small ">100,000</p>
                          </td>
                        </tr>)
                      }
                      
                    </tbody>
                  </table>
                </div>
                <div className="p-5 justify-center md:justify-between flex mb-2">
                  <div className="md:flex gap-2 hidden">
                    <span className="text-small flex items-center">Show</span>
                    <select className="text-small">
                      <option>10</option>
                      <option>20</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                    <span className="text-small flex items-center">Per Page</span>
                  </div>
                  <div className="flex gap-2">
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                    <span className="text-small flex items-center px-2">Page 1 of 25</span>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                    <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-gray-700 dark:text-gray-300 text-xsmall flex items-center mt-5">
            <span className="text-large mr-1 mb-1"><HiOutlineLightBulb /></span>
            <span>
              A token serves as a digital representation of an asset, whether it's on the blockchain or not. The token overview page provides details like current price, total supply, number of holders, transaction history, and links to social media. Discover more
              <span className="text-green-900 ml-1">Knowledge Hub</span>.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderBoard;
